/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  spells: [],
};

const slice = createSlice({
  name: 'spell',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET spell
    getspellSuccess(state, action) {
      state.isLoading = false;
      state.spells = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


export function getSpells(currentUser, paginate, pageIndex, pageSize) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {};
      if (paginate) params.paginate = paginate;
      if (pageIndex) params.page = pageIndex;
      if (pageSize) params.per_page = pageSize;
      const rolePath = currentUser === 'admin' ? '' : currentUser === 'company' ? '/company' : '/clinic';
      const response = await axios.get(`/api${rolePath}/providers`, { params });
      dispatch(slice.actions.getspellSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
